<template>
  <div class="detail-head">
    <div class="head-content">
      <div class="image-section">
        <div class="image-placeholder">
          <el-image
            :src="data.defaultImageUrl || '/image/static/img/nopic.jpg'"
            :preview-src-list="[
              data.defaultImageUrl || '/image/static/img/nopic.jpg',
            ]"
            style="width: 100px; height: 66px"
            fit="cover"
          >
            <div slot="error" class="image-slot">
              <img
                src="/image/static/img/nopic.jpg"
                style="width: 100px; height: 66px"
              />
            </div>
          </el-image>
        </div>
      </div>
      <div class="info-section">
        <div class="info-row">
          <span class="label">{{this.$l("table_label_fabric_color_no") || "面料颜色编号:"}}：</span>
          <span class="value">{{ data.fabricColorNo || "AB525080001-1" }}</span>
        </div>
        <div class="info-row">
          <span class="label">库存门幅：</span>
          <span class="value">{{ data.wid || "" }}</span>
          <span class="label ml-4">库存克重：</span>
          <span class="value">{{ data.fabricWeight || "" }}</span>
        </div>
        <div class="info-row">
          <span class="label">库存数量：</span>
          <span class="value">{{ data.stockQuantity || "" }}</span>
          <span class="label ml-4">{{this.$l("form_label_biz_user") || "业务员"}}：</span>
          <span class="value">{{ data.fabricAgentName || "" }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DetailHead",
  props: {
    data: {},
  },
};
</script>

<style lang="scss" scoped>
.detail-head {
  padding: 20px 0;
  margin-bottom: 20px;

  .head-content {
    display: flex;
    align-items: flex-start;

    .image-section {
      margin-right: 30px;

      .image-placeholder {
        width: 120px;
        height: 100px;
        border: 1px solid #ddd;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f9f9f9;

        img {
          max-width: 100%;
          max-height: 100%;
          object-fit: cover;
        }

        .no-image {
          color: #999;
          font-size: 14px;
        }
      }
    }

    .info-section {
      flex: 1;

      .info-row {
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        font-size: 14px;

        &:first-child {
          .value {
            font-size: 16px;
            font-weight: bold;
          }
        }

        .label {
          color: #333;
          font-weight: 400;
          min-width: 80px;
        }

        .value {
          color: #333;
          font-weight: 500;
        }

        .ml-4 {
          margin-left: 60px;
        }
      }
    }
  }
}
</style>
